import {AxiosRequestConfig} from 'axios';
import {WizRequestOptions} from '@/interface';
import {ServerConfig} from '@/config/routers';
import type dayjs from 'dayjs';
import type classnames from 'classnames';
import type {IHotkeysOptions, IHotkeyCallback, IRegisteredKuHotKey} from '@/hotkeys/typings';
import type * as lodash from 'lodash-es';

export enum RepType {
    Click = 'click',
    Show = 'show',
}

export interface IKuLogger {
    repId: string;
    params?: any;
    type?: RepType;
}

export interface IRegisterOptions {
    hotkey: string;
    callback: IHotkeyCallback;
    options?: IHotkeysOptions;
}


export interface IUtils {
    [key: string]: any;
    request: (options: WizRequestOptions) => Promise<any>;
    axios: (options: AxiosRequestConfig) => Promise<any>;
    ksRequest: (options: WizRequestOptions) => Promise<any>;
    asRequest: (options: WizRequestOptions) => Promise<any>;
    rteRequest: (options: WizRequestOptions) => Promise<any>;
    kuLogger: (options: IKuLogger) => void;
    getServerConfig: () => typeof ServerConfig;
    dayjs: typeof dayjs;
    getToken: (ak: string) => Promise<string>;
    registerKuHotKey: (options: IRegisterOptions) => void;
    unregisterKuHotKey: (hotkey: string) => void;
    getRegisteredHotkeys: () => IRegisteredKuHotKey[];
    hotkeyTrim: (hotkey: string) => string;
    isInKuShare: () => boolean;
    classnames: (...args: classnames.ArgumentArray) => string;
    lodash: () => typeof lodash;
}
